import axios from "axios";
import Swal from 'sweetalert2'


const agregarComplementoPedido = async (cartItems, id, usePoints = false, setCartItems) => {
  try {
    const res = await axios.post('/api/products/addComplemento', { id });
    if (res.status === 200) {
      const { data: complementos } = res.data;
      
      const itemApi = complementos[0];
      const esComplementoPuntos = itemApi.tipo_servicio === 'complemento' && itemApi.puntos_complemento > 0;

      const nuevoItem = {
        id: itemApi.id,
        producto: itemApi.producto,
        precio: itemApi.descuento > 0 ? itemApi.descuento : itemApi.precio,
        imagen: itemApi.images?.find(img => img.caratula === 1)?.name_imagen ?? '/images/img/noimagen.jpg',
        cantidad: 1,
        sku: itemApi.sku,
        tipo: 'Complemento',
        fecha: '',
        horario: '',
        extract: itemApi.extract,
        // Solo asignamos puntos/usePoints si el ítem aplica
        ...(esComplementoPuntos && {
          points: itemApi.puntos_complemento,
          usePoints: Boolean(usePoints)
        })
      };

      let carrito = [...(cartItems ?? [])];
      
      // Búsqueda por ID Y por la bandera de puntos
      const indexExistente = carrito.findIndex(item => 
        item.id === nuevoItem.id && Boolean(item.usePoints) === Boolean(nuevoItem.usePoints)
      );

      if (indexExistente !== -1) {
        // Si existe exacto (mismo ID y mismo estado de puntos), sumamos cantidad
        carrito[indexExistente] = {
          ...carrito[indexExistente],
          cantidad: carrito[indexExistente].cantidad + 1
        };
      } else {
        // Si no coincide el usePoints, entra como un nuevo elemento al arreglo
        carrito.push(nuevoItem);
      }

      setCartItems(carrito);
      return carrito;
    }
  } catch (error) {
    console.error(error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Hubo un error al agregar el pedido. Por favor, inténtelo de nuevo.',
    });
  }
};
export default agregarComplementoPedido;